import { flash, Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { useMutation } from "react-query";
import { CollectionNode } from "types";
import { api } from "@/api/api";
import { SecondaryButton } from "@/components/Common/SecondaryButton";
import { useInvalidate } from "@/hooks/useInvalidation";

interface DeleteCollectionModalProps {
    onClose: () => void;
    isOpen: boolean;
    collection: CollectionNode;
}

export const DeleteCollectionModal = ({ collection, onClose, isOpen }: DeleteCollectionModalProps) => {
    const invalidate = useInvalidate();

    const { mutateAsync: deleteCollection, isLoading } = useMutation(async (collection: CollectionNode) => {
        const response = await api.delete(`/collectionNodes/${collection.id}`);
        invalidate("collectionNodes");
        return response;
    });

    const handleConfirm = async () => {
        try {
            await deleteCollection(collection);
            flash.success("Collection deleted successfully");
            onClose();
        } catch {
            onClose();
        }
    };

    return (
        <Modal shouldCloseOnOutsideClick size="medium" isOpen={isOpen} onClose={onClose}>
            <Modal.Header>Delete Collection?</Modal.Header>
            <Modal.Body>
                <p className="p1">
                    Deleting this collection will also remove any nested collections. Your products will not be
                    affected. This action cannot be undone.
                </p>
            </Modal.Body>
            <Modal.Footer className="space-x-4">
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                <SubmitButton color="danger" isLoading={isLoading} onClick={handleConfirm}>
                    Delete
                </SubmitButton>
            </Modal.Footer>
        </Modal>
    );
};
